import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router";
import { IonContent, IonPage } from "@ionic/react";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import BackButton from "../../../components/common/BackButton";
import SingleAppointmentComponent from "./SingleAppointmentComponent";
import NavigoServices from "../../../services/NavigoServices";
import noSlotVector from "../../../assets/images/no-slots.svg";
import tickimg from "../../../assets/images/tick.png";
import {
  createDateAndChangeScreen,
  stringToIntTime,
  getStringSlot,
} from "../utilityFunctions";
import useUnhidePageOnEnter from "../../../hooks/useUnhidePageOnEnter";

const NavigoReschedule = () => {
  // Ionic can leave this page `ion-page-hidden` on re-entry, blanking it.
  const pageRef = useUnhidePageOnEnter();
  const location = useLocation();
  const history = useHistory();

  const locationState = location.state || {};
  const savedState = (() => {
    try {
      const raw = sessionStorage.getItem("rescheduleData");
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  })();
  const stateData = locationState.provider ? locationState : savedState;
  const { provider, service, appointment } = stateData;

  const [dateArr, setDateArr] = useState([]);
  const [dateSelected, setDateSelected] = useState(-1);
  const [slots, setSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!service || !appointment) {
      history.goBack();
      return;
    }

    const dates = createDateAndChangeScreen(
      provider?.minBookingDays || 0,
      provider?.maxBookingDays || 7,
    );
    setDateArr(dates);

    if (dates.length > 0) {
      fetchSlots(dates[0].exactDate, 0);
    }
  }, []);

  const fetchSlots = (date, dateIndex) => {
    setLoadingSlots(true);
    setSelectedSlot(null);
    setDateSelected(dateIndex);
    setAppointmentDate(date);

    const mode = service?.serviceModeDetails?.[0]?.modeName;
    const isLabTest = mode === "Home sample";

    let body = {
      bookingMode: mode,
      collectionDate: moment(date).format("YYYY-MM-DD"),
      planId: service?.planId,
      serviceId: service?.serviceId,
      vendor: appointment?.vendorId || "",
      vendorCode: appointment?.vendorCode || "",
    };

    if (isLabTest) {
      body.addressId = appointment?.addressId || "";
    } else {
      body.serviceProviderId = provider?.id || "";
    }

    console.log("Reschedule - fetchSlots body:", JSON.stringify(body));

    NavigoServices.getAllTimeSlots(body)
      .then((res) => {
        console.log(
          "Reschedule - slot API response:",
          JSON.stringify(res?.data),
        );
        const data = res?.data;
        let allSlots = [];
        if (data && data.slots && data.slots.length > 0) {
          allSlots = data.slots.map((slt) => ({
            id: slt.key,
            time: getStringSlot(slt.value),
            serviceProviderId: data.serviceProviderId,
          }));
        }
        setSlots(allSlots);
        setLoadingSlots(false);
      })
      .catch((err) => {
        console.error("Reschedule - slot API error:", err);
        setSlots([]);
        setLoadingSlots(false);
      });
  };

  const handleReschedule = () => {
    if (!selectedSlot || !appointmentDate) return;

    setIsSubmitting(true);
    setError("");

    const body = {
      appointmentID: appointment.ID,
      addressId: appointment.addressId || 0,
      appointmentDate: new Date(
        moment(appointmentDate).add(1, "h").format(),
      ).toISOString(),
      serviceProviderID: selectedSlot.serviceProviderId || provider?.id || 0,
      timeSlot: stringToIntTime(selectedSlot.time),
      timeSlotId: selectedSlot.id,
      vendor: appointment.vendorId || "",
      vendorCode: appointment.vendorCode || "",
    };

    NavigoServices.rescheduleAppointments(body)
      .then(() => {
        setIsSubmitting(false);
        history.replace(
          `/mliNavigo/bookingCard?date=${moment(appointmentDate).format(
            "DD MMM, YYYY",
          )}&time=${selectedSlot.time}`,
        );
      })
      .catch(() => {
        setIsSubmitting(false);
        setError("Reschedule failed. Please try again.");
      });
  };

  if (!service || !appointment) {
    return null;
  }

  return (
    <IonPage ref={pageRef}>
      <IonContent>
        {isSubmitting && (
          <div className="booking-loader-blur">
            <div className="w-10 h-10 mb-4 border-4 border-t-4 border-[#97144D] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-[#97144D] font-medium text-lg">
              Rescheduling your appointment...
            </p>
          </div>
        )}
        <div className="navigo-booking-screen-3-container">
          <div>
            <BackButton />
            <p className="navigo-booking-screen-3-mid-service-name">
              {appointment.serviceName || "Reschedule Appointment"}
            </p>
            <div className="navigo-booking-screen-3-mid">
              <div className="navigo-booking-screen-3-mid-progress">
                <div className="navigo-booking-container-section-3-ele">
                  <SingleAppointmentComponent
                    serviceName={"Old appointment"}
                    date={appointment.appointmentDate}
                  />
                </div>
              </div>

              <div className="navigo-booking-screen-3-calendar">
                {dateArr.map((dt, dateIndex) => (
                  <div
                    key={dateIndex}
                    className={`navigo-booking-screen-3-calendar-date ${
                      dateSelected === dateIndex
                        ? "navigo-booking-screen-3-calendar-date-selected"
                        : ""
                    }`}
                    onClick={() => fetchSlots(dt.exactDate, dateIndex)}
                  >
                    <span>
                      {dt.day}&nbsp;{dt.month}
                    </span>
                  </div>
                ))}
              </div>

              <div className="navigo-booking-screen-3-bottom-parent">
                <div className="navigo-booking-screen-3-bottom">
                  {!loadingSlots &&
                    slots.length > 0 &&
                    slots.map((slt) => (
                      <div
                        key={slt.id}
                        className={`navigo-booking-screen-3-bottom-ele ${
                          selectedSlot && selectedSlot.id === slt.id
                            ? "navigo-booking-screen-3-bottom-ele-selected"
                            : ""
                        }`}
                        onClick={() => setSelectedSlot(slt)}
                      >
                        <p>{slt.time}</p>
                        {selectedSlot && selectedSlot.id === slt.id && (
                          <img src={tickimg} alt="icon" />
                        )}
                      </div>
                    ))}
                  {!loadingSlots && slots.length === 0 && (
                    <div className="navigo-booking-screen-3-bottom-no-slots">
                      <img src={noSlotVector} alt="bg-img" />
                      <p>
                        Oops! no free slot available,
                        <br /> try some other date
                      </p>
                    </div>
                  )}
                  {loadingSlots && (
                    <CircularProgress className="navigo-no-slots-loader" />
                  )}
                </div>
              </div>

              {error && (
                <p className="text-red-500 text-sm text-center mt-2">{error}</p>
              )}

              <div className="navigo-booking-screen-3-button">
                <button
                  disabled={!selectedSlot || !appointmentDate || loadingSlots}
                  onClick={handleReschedule}
                >
                  Reschedule
                </button>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NavigoReschedule;
